import { buildBase } from "./constants";

const BASE = buildBase("network");
const CUSTOMERS_BASE = `${BASE}/customers`;

export const NETWORK_ROUTES = (() => {
  /*
    ======================================================
    ADD ALL BASIC ROUTES HERE
    ======================================================
  */
  const basicRoutes = {
    ROOT: BASE,
  };

  /*
    ======================================================
    ADD ALL ROUTES THAT REQUIRE NESTING BELOW
    ======================================================
  */

  // Customer management routes
  const CUSTOMERS = {
    ROOT: CUSTOMERS_BASE,
    MERGE: `${CUSTOMERS_BASE}/merge`,
    detail: (id: string) => `${CUSTOMERS_BASE}/${id}`,
    transactions: (id: string) => `${CUSTOMERS_BASE}/${id}/transactions`,
    notes: (id: string) => `${CUSTOMERS_BASE}/${id}/notes`,
    holds: (id: string) => `${CUSTOMERS_BASE}/${id}/holds`,
    memberships: (id: string) => `${CUSTOMERS_BASE}/${id}/memberships`,
    credits: (id: string) => `${CUSTOMERS_BASE}/${id}/credits`,
    SEGMENTS: {
      ROOT: `${CUSTOMERS_BASE}/segments`,
      detail: (id: string) => `${CUSTOMERS_BASE}/segments/${id}`,
    },
    SMS_CAMPAIGN: `${CUSTOMERS_BASE}/sms-campaign`,
    EMAIL_CAMPAIGN: `${CUSTOMERS_BASE}/email-campaign`,
    RATINGS: `${CUSTOMERS_BASE}/ratings`,
  };

  return {
    ...basicRoutes,
    CUSTOMERS,
  };
})();
